import React, { Component } from "react";
import Banner from './Banner';
import About from './About';
import Vision from './Vision';
import Services from './Services';
import Partners from './Partners';
import Projects from './Projects';
import OtherProjects from './OtherProjects';
import Contact from './Contact';
import './Home.css';

export default class Home extends Component {
  constructor(props) {
    super(props);
    this.refHome = React.createRef();
    this.refAbout = React.createRef();
    this.refServices = React.createRef();
    this.refProjects = React.createRef();
    this.refOtherProjects = React.createRef();
    this.refContact = React.createRef();
    this.state = {};
  }
  componentDidMount() {
    if (this.props.onRef) {
      this.props.onRef(this);
    }
  }
  componentWillUnmount() {
    this.props.onRef(undefined);
  }
  scrollTo = (to) => {
    let ref = this.refHome;
    if (to === '#about') {
      ref = this.refAbout;
    } else {
      if (to === '#services') {
        ref = this.refServices;
      } else {
        if (to === '#projects') {
          ref = this.refProjects;
        } else {
          if (to === '#otherProjects') {
            ref = this.refOtherProjects;
          } else {
            if (to === '#contact') {
              ref = this.refContact;
            }
          }
        }
      }
    }
    window.scrollTo({
      top: ref.current.offsetTop,
      behavior: 'smooth'
    });
  }
  handleContact = () => {
    this.scrollTo('#contact');
  }
  render() {
    return (
      <div className="Home" ref={this.refHome}>
        <section id="banner">
          <Banner onContact={this.handleContact} />
        </section>
        <section id="about" className="section about" ref={this.refAbout}>
          <About />
        </section>
        <section id="vision" className="section vision">
          <Vision />
        </section>
        <section id="services" className="section services" ref={this.refServices}>
          <Services />
        </section>
        <section id="projects" className="section projects" ref={this.refProjects}>
          <Projects />
        </section>
        <section id="otherProjects" className="section projects" ref={this.refOtherProjects}>
          <OtherProjects />
        </section>
        <section id="partners" className="section partners">
          <Partners />
        </section>
        <section id="contact" className="section contact" ref={this.refContact}>
          <Contact />
        </section>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Home.js